import axios from 'axios';

const baseUrl = process.env.BASE_API
// 导出事件
export function downloadDevices(method,url,params={}) {
  return axios({
    url: baseUrl + url,
    method: method,
    responseType: "blob",
    data: params,
    timeout: 5 * 60 * 1000
  })
}




// WEBPACK FOOTER //
// ./src/api/excel.js